import React from 'react';
import {styled} from '@mui/system';
import ContainerContent from "../container/ContainerContent";
import ContainerBlock from "../container/ContainerBlock";
import Container from "../container/Container";

export const StyledPage = styled('div')({
    overflow: 'hidden',
    minHeight: '100vh',
    backgroundColor: 'var(--gov-color-grey-bg)',
    color: 'var(--gov-color-grey-mid)',
    fontFamily: '"Roboto", sans-serif',
    fontSize: '0.9375rem',
    fontWeight: 400,
    letterSpacing: '0.0125em',
    WebkitFontSmoothing: 'antialiased',
});

const StyledHeading = styled('h1')({
    fontFamily: '"Roboto", sans-serif',
    fontWeight: 300,
    letterSpacing: '0.0125em',
    lineHeight: 1.2,
    fontSize: '2.5rem',
    marginBottom: '2.5rem',
    WebkitFontSmoothing: 'antialiased',
});

export interface PageProps {
    title: string;
    children?: React.ReactNode;
    // When false, children are rendered directly so a page can compose its own
    // ContainerBlock(s) — e.g. several separate containers instead of one.
    contentBlock?: boolean;
}

export default function Page(props: PageProps) {
    const {title, children, contentBlock = true} = props;

    return (
        <StyledPage>
            <Container>
                <ContainerContent>
                    <StyledHeading>{title}</StyledHeading>
                    {contentBlock ? <ContainerBlock>{children}</ContainerBlock> : children}
                </ContainerContent>
            </Container>
        </StyledPage>
    );
}